import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import DefaultLayout from "layouts/Default";
import {wrapper} from "lib/store";
import {getServiceCategories} from "lib/services/product";
import {getDealsByProductCategory} from "lib/services/deals";
import ProductListing from "components/views/ProductListing";
import React, {useEffect, useState} from "react";
import LocationLayout from "layouts/LocationLayout";
import {useDispatch, useSelector} from "react-redux";
import {getLocation} from "lib/features/locationSlice";
import {useRouter} from "next/router";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {getPaginatedServicesThunk} from "lib/features/productSlice";

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
    const {
        query,locale,
    } = context
    await store.dispatch(getLocation({slug: query.locationSlug, id: query.id}))
    const allDeals = await getDealsByProductCategory()
    const CATEGORIES = await getServiceCategories()

    const {
        page = 1,
        sort = {},
        deals = [],
        categories = [],
        brandVerified = false,
        brands = [],
        strainTypes = [],
        priceRanges = [],
        weights = [],
    } = query

    const filter = {
        deals,
        categories,
        brandVerified,
        brands,
        strainTypes,
        priceRanges,
        weights,
    }

    return {
        props: {
            allDeals,
            page,
            filter,
            sort,
            CATEGORIES,
            ...(await serverSideTranslations(locale, ['home', 'common']))
        }
    }
})

export default function StoreServiceDetail(props) {
    const {
        page: _page,
        filter: _filter,
        sort: _sort,
        allDeals: deals,
        CATEGORIES,
    } = props

    const { t } = useTranslation()
    const dispatch = useDispatch()
    const location = useSelector(state => state.location.location)
    let services = useSelector(state => state.product.services)
    let brands = useSelector(state => state.brand.brands)
    const router = useRouter()
    const [filteredServices, setFilteredServices] = useState([])
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        if (!!location.services && services.length > 1) {
            let relatedServicesId = location.services.includes(',') ? location.services.split(', ') : [location.services]
            console.log('here: ', relatedServicesId, services)
            let tempServices = relatedServicesId.map(item => {
                let service = services.find(p => p.id === item)
                if (!!service) {
                    return service
                } else {
                    return {id: "-1"}
                }
            })
            console.log('at service tab: ', tempServices)
            setFilteredServices(tempServices.filter(item => Number(item.id) > 0))
        }
        setLoaded(true)
    }, [services, location])

    useEffect(() => {
        if (services[0].id === 0 && services.length === 1) {
            dispatch(getPaginatedServicesThunk({_page, _filter, _sort}))
        }
    }, [])
    return (
        <Wrapper>
            <Container>
                {
                    loaded ?
                        <ProductListing
                            _filter={_filter} _page={_page} _sort={_sort}
                            products={filteredServices} deals={deals} brands={brands}
                            type={'Service'} categories={CATEGORIES}
                            baseUrl={`/stores/${location.slug}/servicemenu`}
                        /> : null
                }
            </Container>
        </Wrapper>
    )
}


StoreServiceDetail.getLayout = function getLayout(page) {
    return (
        <DefaultLayout>
            <LocationLayout>
                {page}
            </LocationLayout>
        </DefaultLayout>
    )
}
